import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { APP_BASE_HREF } from '@angular/common';
import { DanglIdentityModule } from '@dangl/angular-dangl-identity-client';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideRouter } from '@angular/router';
import { routes } from './app.route';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from './constants/format';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(DanglIdentityModule, NgxChartsModule),
    provideMomentDateAdapter(),
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: APP_BASE_HREF, useValue: '/' },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimations(),
    provideZoneChangeDetection(),
    provideRouter(routes)
  ]
};
